import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import Inward from "@/pages/Inward";
import Outward from "@/pages/Outward";
import Items from "@/pages/Items";
import GatePass from "@/pages/GatePass";
import Users from "@/pages/Users";
import Diesel from "@/pages/Diesel";
import Meters from "@/pages/Meters";
import FuelSettings from "@/pages/FuelSettings";
import Parties from "@/pages/Parties";
import PartyLedger from "@/pages/PartyLedger";
import Invoices from "@/pages/Invoices";
import VendorInvoices from "@/pages/VendorInvoices";
import PurchaseOrders from "@/pages/PurchaseOrders";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-2 border-sky-500 border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="inward" element={<Inward />} />
              <Route path="outward" element={<Outward />} />
              <Route path="items" element={<Items />} />
              <Route path="gatepass" element={<GatePass />} />
              <Route path="diesel" element={<Diesel />} />
              <Route path="parties" element={<Parties />} />
              <Route path="parties/:id" element={<PartyLedger />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="vendor-invoices" element={<VendorInvoices />} />
              <Route path="purchase-orders" element={<PurchaseOrders />} />
              <Route path="meters" element={<Meters />} />
              <Route path="fuel-settings" element={<FuelSettings />} />
              <Route path="users" element={<Users />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
